import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './ConferenceNavigation.css';

const ConferenceNavigation = () => {
  const [activeButton, setActiveButton] = useState("ASG Connect 2025");

  const buttons = [
    { label: "ASG Connect 2025", path: '/asg-conference2025' },
    { label: "ASG Connect 2024", path: '/asg-conference2024' },
    { label: "6th African Act. Conf", path: "" },
    { label: "ASG Connect 2021", path: "" },
    { label: "ASG Convention 2019", path: "" },
    { label: "ASG Convention 2018", path: "" },
    { label: "20th Anniversary Convention", path: "" },
  ];

  return (
    <div className='recent-posts' style={{
        backgroundColor: 'transparent',
        overflow: 'hidden',
        border: 'none',
        boxShadow: 'none',
      }}
 >
    <div className="Nav-container">
      <h1 className="Nav-header">ASG Conference</h1>
      <div className="Nav-button-container">
    <div className='Naviation-Arrow'>
        {/* Arrow Indicator and Tail */}
        <motion.div
          className="arrow-indicator-tail"
          animate={{ height: buttons.findIndex(button => button.label === activeButton) * 60 + 30 }}
          transition={{ type: 'spring', stiffness: 100 }}
        />
        <motion.div
          className="arrow-indicator"
          animate={{ y: buttons.findIndex(button => button.label === activeButton) * 60 }}
          transition={{ type: 'spring', stiffness: 100 }}
        /> 
    </div>

        {/* Buttons */}
        {buttons.map((button, index) => (
          <Link
            to={button.path}
            key={index}
            className={`nav-button ${activeButton === button.label ? "active" : ""}`}
            onClick={() => setActiveButton(button.label)}
          >
            {button.label}
          </Link>
        ))}
      </div>
    </div>
    </div>
  );
};

export default ConferenceNavigation;
